export function getPdfPreviewScrollState(
  viewport: HTMLElement,
  pages: HTMLElement[],
  currentPageNumber: number
) {
  if (viewport.clientHeight === 0 || pages.length === 0) {
    return null;
  }

  const top = viewport.scrollTop;
  const bottom = top + viewport.clientHeight;
  // Keep one viewport of canvases on either side of the visible pages.
  const renderTop = top - viewport.clientHeight;
  const renderBottom = bottom + viewport.clientHeight;
  const left = viewport.scrollLeft;
  const right = left + viewport.clientWidth;
  const visibleAreas = pages.map((page) => {
    const height = Math.max(
      0,
      Math.min(bottom, page.offsetTop + page.offsetHeight) - Math.max(top, page.offsetTop)
    );
    const width = Math.max(
      0,
      Math.min(right, page.offsetLeft + page.offsetWidth) - Math.max(left, page.offsetLeft)
    );
    return height * width;
  });
  const largestArea = visibleAreas.reduce((largest, area) => Math.max(largest, area), 0);
  const currentArea = visibleAreas[currentPageNumber - 1];
  const pageNumber =
    largestArea === 0 || currentArea === largestArea
      ? currentPageNumber
      : visibleAreas.indexOf(largestArea) + 1;
  const firstIndex = pages.findIndex((page) => page.offsetTop + page.offsetHeight > renderTop);
  const lastIndex = pages.findLastIndex((page) => page.offsetTop < renderBottom);

  return {
    pageNumber,
    firstRenderedPage: Math.max(0, firstIndex) + 1,
    lastRenderedPage: Math.max(0, lastIndex) + 1,
  };
}
